import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import { Spinner } from '@/ui-kit'
import { useUiKit } from '@/ui-kit/providers'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export const WebviewJwtFromUrl = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const jwtFromUrl = searchParams.get('jwt')
  const themeFromUrl = searchParams.get('theme')
  const { setIsThemeDark } = useUiKit()

  useEffect(() => {
    const next = new URLSearchParams(location.search)
    if (themeFromUrl) {
      setIsThemeDark(themeFromUrl === 'dark')
      next.delete('theme')
    }

    next.delete('lng')

    if (!jwtFromUrl) return
    try {
      localStorage.setItem(LOCAL_STORAGE_KEY_JWT, JSON.stringify(jwtFromUrl))
    } finally {
      next.delete('jwt')

      const nextSearch = next.toString()
      const nextUrl = nextSearch ? `${location.pathname}?${nextSearch}` : location.pathname
      navigate(nextUrl, { replace: true })
    }
  }, [jwtFromUrl, location.pathname, location.search, navigate, setIsThemeDark, themeFromUrl])

  if (jwtFromUrl) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return <>{children}</>
}
